export const LOGIN_METHOD_ENUM = {
  OTP: "OTP",
  EPIN: "EPIN",
};

export const  OTP_PURPOSE_ENUM = {
  REGISTER: "REGISTER",
  LOGIN: "LOGIN",
  RESET: "RESET"
}